module.exports = __webpack_public_path__ + "static/media/tommySleeve0.13d7f5a0.svg";